import { getStartedPaths } from 'features/get-started/routes/paths';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { editProfileRequest } from 'features/user/api';
import { profileSuccess } from 'features/user/redux/actions';

const useGetStarted = () => {
  const { push } = useHistory();
  const dispatch = useDispatch();
  const backToDashboard = async () => {
    const response = await editProfileRequest({ show_started_tips: false });
    dispatch(profileSuccess(response.data));
  };
  const onHandleSkipAndNext = () => push(getStartedPaths.static.secondStep);

  return {
    backToDashboard,
    onHandleSkipAndNext,
  };
};

export default useGetStarted;
